import React from "react";
import {
  Modal,
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
} from "react-native";
import { AppColors } from "../../utility/AppColors";
import { streamingToolsUrl } from "../../Api/configs";
import { useWsProvider } from "../../context/NativeApplicationContext";

interface ManageSourcesModalProps {
  visible: boolean;
  onClose: () => void;
}

const ManageSourcesModal: React.FC<ManageSourcesModalProps> = ({
  visible,
  onClose,
}) => {
  const { broadcasterId, isNativeAppConnected } = useWsProvider();
  
  // Only build URL if we have broadcaster ID
  const iframeSrc = broadcasterId 
    ? `${streamingToolsUrl}?broadcasterId=${encodeURIComponent(broadcasterId)}`
    : null;
  
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.modalContainer}>
        <View style={styles.modalContent}>
          {isNativeAppConnected && iframeSrc ? (
            <iframe
              src={iframeSrc}
              style={{ width: "100%", height: "80vh", border: "none" }}
              title="Manage Sources"
            />
          ) : (
            <View style={{ padding: 40, alignItems: "center" }}>
              <Text style={{ color: AppColors.gray_7E7E7E, fontSize: 16 }}>
                {isNativeAppConnected ? "Loading..." : "Native app not connected"}
              </Text>
            </View>
          )}
          <TouchableOpacity
            onPress={onClose}
            style={styles.closeButton}
          >
            <Text style={styles.closeButtonText}>Close</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    width: "90%",
    maxWidth: 1200,
    backgroundColor: AppColors.white,
    borderRadius: 10,
    padding: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  closeButton: {
    marginTop: 15,
    backgroundColor: AppColors.appViolentColor_6D08C3,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
    alignSelf: "center",
  },
  closeButtonText: {
    color: AppColors.white,
    fontSize: 16,
    fontWeight: "bold",
  },
});

export default ManageSourcesModal;
